module.exports = __webpack_public_path__ + "img/github.358847e2.svg";